(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9344],{

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ login_Login; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/config/sitemap.ts
var sitemap = __webpack_require__(65723);
// EXTERNAL MODULE: ./src/lib/axios/axios-client.ts
var axios_client = __webpack_require__(77730);
// EXTERNAL MODULE: ./src/components/containers/index.tsx + 1 modules
var containers = __webpack_require__(96949);
// EXTERNAL MODULE: ./src/components/containers/SideBannerContentContainer.tsx
var SideBannerContentContainer = __webpack_require__(21520);
// EXTERNAL MODULE: ./src/components/molecules/LogoWithTitle/index.tsx + 1 modules
var LogoWithTitle = __webpack_require__(95259);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
// EXTERNAL MODULE: ./src/components/atoms/Fonts/index.tsx
var Fonts = __webpack_require__(73648);
;// CONCATENATED MODULE: ./src/components/organisms/LoginForm/styled.tsx


var LoginFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LoginFormContainer",
  componentId: "sc-12ut3z9-0"
})(["width:100%;height:100%;"]);
var FieldWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__FieldWrapper",
  componentId: "sc-12ut3z9-1"
})([":not(:nth-child(2)){margin:24px 0;}display:flex;flex-direction:column;"]);
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__ButtonWrapper",
  componentId: "sc-12ut3z9-2"
})([""]);
var ForgotPasswordLabel = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* BodyText1 */.NE).withConfig({
  displayName: "styled__ForgotPasswordLabel",
  componentId: "sc-12ut3z9-3"
})(["color:", ";float:right;margin:8px 0 24px 0;"], function (props) {
  return props.theme.colors.text["default"];
});
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./src/components/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(74398);
// EXTERNAL MODULE: ./src/components/atoms/Button/index.tsx + 1 modules
var Button = __webpack_require__(71800);
// EXTERNAL MODULE: ./src/components/organisms/PasswordField/PasswordField.tsx + 1 modules
var PasswordField = __webpack_require__(60988);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/organisms/LoginForm/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var schema = es/* object */.Ry().shape({
  username: es/* string */.Z_().required('Username is required'),
  password: es/* string */.Z_().required('Password is required')
});

var LoginForm = function LoginForm(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LoginFormContainer, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      onSubmit: function onSubmit(values) {
        return props.onSubmit(values);
      },
      initialValues: {
        username: '',
        password: ''
      },
      validationSchema: schema,
      validateOnBlur: false,
      validateOnChange: false,
      children: function children(_ref) {
        var errors = _ref.errors,
            isSubmitting = _ref.isSubmitting;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "username",
              children: function children(field) {
                var _props$initialErrors;

                return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, _objectSpread(_objectSpread({
                  name: "username",
                  size: 'lg'
                }, field), {}, {
                  placeholder: 'Email',
                  type: "email",
                  errorMessage: errors['username'] || ((_props$initialErrors = props.initialErrors) === null || _props$initialErrors === void 0 ? void 0 : _props$initialErrors.username)
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FieldWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
              name: "password",
              children: function children(field) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordField/* default */.Z, _objectSpread(_objectSpread({
                  name: "password",
                  size: 'lg'
                }, field), {}, {
                  placeholder: 'Password',
                  errorMessage: errors['password']
                }));
              }
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/auth/forgot-password",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ForgotPasswordLabel, {
              children: "Forgot Password?"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
              size: 'lg',
              variant: 'primary',
              block: true,
              type: "submit",
              disabled: isSubmitting,
              children: "LOG IN"
            })
          })]
        });
      }
    })
  });
};

/* harmony default export */ var organisms_LoginForm = (LoginForm);
// EXTERNAL MODULE: ./src/styles/breakpoints/index.ts
var breakpoints = __webpack_require__(15143);
;// CONCATENATED MODULE: ./src/components/pages/Login/styled.tsx



var Title = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* Header1 */.R6).withConfig({
  displayName: "styled__Title",
  componentId: "sc-16q94qv-0"
})(["color:white;margin-bottom:24px;"]);
var LoginPageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LoginPageContainer",
  componentId: "sc-16q94qv-1"
})(["height:100%;display:flex;"]);
var SignUpWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__SignUpWrapper",
  componentId: "sc-16q94qv-2"
})(["display:flex;align-items:center;justify-content:center;margin-top:24px;"]);
var SignUpQuestion = (0,styled_components_browser_esm/* default */.ZP)(Fonts/* BodyText1 */.NE).withConfig({
  displayName: "styled__SignUpQuestion",
  componentId: "sc-16q94qv-3"
})(["color:", ";margin-right:8px;"], function (props) {
  return props.theme.colors.text["default"];
});
var RightSideInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__RightSideInner",
  componentId: "sc-16q94qv-4"
})(["display:flex;flex-direction:column;width:100%;margin:80px 20px;justify-content:start;align-items:center;@media ", "{margin:80px 50px;}@media ", "{margin:80px 26px;}"], breakpoints/* device.tablet */.U.tablet, breakpoints/* device.mobile */.U.mobile);
var LoginFormWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__LoginFormWrapper",
  componentId: "sc-16q94qv-5"
})(["max-width:352px;width:100%;"]);
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__HeaderWrapper",
  componentId: "sc-16q94qv-6"
})(["margin-bottom:40px;"]);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/pages/Login/index.tsx














var LoginPage = function LoginPage(props) {
  var router = (0,next_router.useRouter)();
  var mutation = (0,useMutation/* useMutation */.D)({
    mutationFn: function mutationFn(input) {
      return axios_client/* api.post */.h.post('/auth/login', {
        username: input.username,
        password: input.password
      });
    },
    onSuccess: function onSuccess(data) {
      if (data.data.ok === true) {
        router.push('/');
      }

      if (data.data.error === 'pending_approval') {
        router.push(sitemap/* SITEMAP.PENDING_APPROVAL */.a.PENDING_APPROVAL);
      }
    },
    onError: function onError() {}
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginPageContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(containers/* SideBannerContainer */.R, {
      maxImageWidth: 700,
      style: {
        backgroundImage: "url(/assets/images/side-banners/login-banner.png)"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: ["THE FUTURE OF SECURITY ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "IS ADVANCED ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "VIDEO MONITORING"]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SideBannerContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(RightSideInner, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoWithTitle/* default */.Z, {
            title: "Welcome Back"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginFormWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(organisms_LoginForm, {
            onSubmit: /*#__PURE__*/function () {
              var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return mutation.mutateAsync(values);

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }(),
            initialErrors: mutation.isError ? {
              username: 'Invalid Email/Password'
            } : undefined
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var Login = (LoginPage);
;// CONCATENATED MODULE: ./src/pages/auth/login.tsx





var __N_SSP = true;
function login_Login() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Dealer Portal - Login"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Login, {})]
  });
}

/***/ }),

/***/ 40163:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login",
      function () {
        return __webpack_require__(82257);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,753,4231,1336,362,9774,2888,179], function() { return __webpack_exec__(40163); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);